import { TagColor } from './ui';

/**
 * @enum {DOC_FIELD_TYPES}
 */
export const DOC_FIELD_TYPES = {
  TEXT: 'Text',
  INTEGER: 'Integer',
  DOUBLE: 'Double',
  BOOL: 'Bool',
  CONTAINER: 'Container',
  TABLE: 'Table',
  COMPLEX: 'Complex',
  DATE: 'Date',
  SINGLE_SELECTION_DROP_DOWN: 'SingleSelectionDropDown',
  MULTIPLE_SELECTION_DROP_DOWN: 'MultipleSelectionDropDown',
  DROP_DOWN_FIELD: 'DropDownField',
};

export const EDIT_DOC_FIELD_TYPE_TYPE = {
  ORDINARY: 'Ordinary',
  OPTION_SELECTION: 'OptionSelection',
};

export const hiddenDocumentFieldTypes = [DOC_FIELD_TYPES.DROP_DOWN_FIELD];
export const dropDownDocumentFieldTypes = [
  DOC_FIELD_TYPES.SINGLE_SELECTION_DROP_DOWN,
  DOC_FIELD_TYPES.MULTIPLE_SELECTION_DROP_DOWN,
];

// Only flat, single-value types reduce to one pipeline cell value; Table/Container/Complex
// and MultipleSelectionDropDown hold nested or multiple values.
export const scalarDocumentFieldTypes = [
  DOC_FIELD_TYPES.TEXT,
  DOC_FIELD_TYPES.INTEGER,
  DOC_FIELD_TYPES.DOUBLE,
  DOC_FIELD_TYPES.BOOL,
  DOC_FIELD_TYPES.DATE,
  DOC_FIELD_TYPES.SINGLE_SELECTION_DROP_DOWN,
];

export const TagColorByDocType = {
  [DOC_FIELD_TYPES.TEXT]: TagColor.GREEN,
  [DOC_FIELD_TYPES.DOUBLE]: TagColor.BLUE,
  [DOC_FIELD_TYPES.INTEGER]: TagColor.YELLOW,
  [DOC_FIELD_TYPES.CONTAINER]: TagColor.PURPLE_DARK,
  [DOC_FIELD_TYPES.TABLE]: TagColor.INDIGO,
  [DOC_FIELD_TYPES.BOOL]: TagColor.RED,
  [DOC_FIELD_TYPES.COMPLEX]: TagColor.PURPLE_LIGHT,
  [DOC_FIELD_TYPES.DATE]: TagColor.PINK,
  [DOC_FIELD_TYPES.SINGLE_SELECTION_DROP_DOWN]: TagColor.ORANGE,
  [DOC_FIELD_TYPES.MULTIPLE_SELECTION_DROP_DOWN]: TagColor.ORANGE_DARK,
};
